import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSHealthApiDetail } from "../api/RCSDashboardApi";

export const useRCSHealthDetail = ({ visible = false }) => {
  const auth = useAuth();
  const user = auth.getSessionData();
  return useQuery({
    queryKey: ["RCSHealthApiDetail", visible],
    queryFn: async () => await getRCSHealthApiDetail({ token: user.token }),
    refetchOnWindowFocus: false,
    enabled: visible,
    keepPreviousData: true,
    initialData: [],
  });
};
